<div class="container">
    <b3-icon name="lock"></b3-icon>
    <h1>Acesso negado</h1>
    <p>Desculpe, você não está autorizado a acessar a pagina que solicitou.</p>
</div>
